type GetPAgeCountRequestParams = {
  count: number;
  rowsPerPage: number;
};

const getPageCount = (params: GetPAgeCountRequestParams) => {
  const { count, rowsPerPage } = params;

  if (count === -1) return 0;

  if (rowsPerPage === -1) return 1;

  return Math.ceil(count / rowsPerPage);
};

export default getPageCount;
